import ScrollToTop from 'react-scroll-up'
import styled from 'styled-components'

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'

import theme from '~/shared/styles/theme'

const ScrollToTopButton: React.FC = () => {
  return (
    <ScrollButton
      showUnder={160}
      style={{
        position: 'fixed',
        border: `1px solid ${theme.colors.mint_3}`,
        borderRadius: '50%',
        width: '60px',
        height: '60px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
      }}
    >
      <IoArrowUpStyled />
    </ScrollButton>
  )
}

export default ScrollToTopButton

const ScrollButton = styled(ScrollToTop)`
  cursor: pointer;

  width: 80px;
  height: 80px;

  color: #8bd2d7;

  background-color: #fff;
  border: 1px solid ${theme.colors.mint_3};

  /* activity_rounded styles */
  border-radius: 50%;
  box-shadow: 0 2px 10px rgb(0 0 0 / 30%);

  @media ${theme.device.large} {
    width: 60px;
    height: 60px;
  }

  @media ${theme.device.medium} {
    width: 20px;
    height: 60px;
  }
`

const IoArrowUpStyled = styled(ArrowUpwardIcon)`
  font-size: 32px;
  color: ${theme.colors.mint_3};

  @media ${theme.device.medium} {
    font-size: 24px;
  }
`
